export default __webpack_public_path__ + "static/media/R_sound.53c32ff6.mp3";